
const contactData = {
	title: "Get in touch ",
	description: [
		"The Standard Bank Tutuwa Community Foundation <b>does not respond</b> to unsolicited requests for funding. Please fill out the form below to get in touch with us for any information that isn’t covered on this site.",
	],
};

export { contactData };
